// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1lmmM","requiredAsterisk":"Info_requiredAsterisk__3bUZZ"};